(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function reorderSplitCardSwatch(card, setInitialChecked) {
    const activeColor = card.dataset.activeColor;
    if (!activeColor) return;
    const inputs = card.querySelectorAll('input[name$="-swatch"]');
    for (const input of inputs) {
      if (input.value === activeColor) {
        // Set checked via JS property only — does not fire change event or trigger fetch
        if (setInitialChecked && !input.checked) input.checked = true;
        const swatchLi = input.closest('li.variant-option__swatch');
        const overflowList = swatchLi?.parentElement;
        if (!overflowList) break;
        const firstSwatch = overflowList.querySelector('li.variant-option__swatch');
        if (firstSwatch !== swatchLi) overflowList.prepend(swatchLi);
        break;
      }
    }
  }

  function setupSplitSwatchObserver(card) {
    const overflowList = card.querySelector('swatches-variant-picker-component overflow-list');
    if (!overflowList) return;
    // morph() matches swatch <li> elements by data-key and moves them to match
    // server order after each click. Watching childList changes lets us re-apply
    // the active-color-first reorder after morph settles.
    new MutationObserver(() => {
      setTimeout(() => reorderSplitCardSwatch(card, false), 0);
    }).observe(overflowList, { childList: true });
  }

  function setupSplitCardImageFix(card) {
    const baseImgKey = card.dataset.baseImgKey;
    const targetImgKey = card.dataset.targetImgKey;
    const baseMediaId = card.dataset.baseMediaId;
    if (!baseImgKey || !targetImgKey || !baseMediaId || baseImgKey === targetImgKey) return;

    const productCard = card.querySelector('product-card');
    if (!productCard) return;

    // Slide 0's image URL was replaced in Liquid (base→target color).
    // When the user selects the base color, #updateVariantImages makes slide 0 visible again
    // but its <img> still shows the replaced (target-color) URL — restore it here.
    productCard.addEventListener('variant:update', function() {
      const variantPicker = productCard.querySelector('swatches-variant-picker-component');
      const selectedOption = variantPicker && variantPicker.querySelector('fieldset input:checked');
      if (!selectedOption) return;

      if (String(selectedOption.dataset.optionMediaId) !== String(baseMediaId)) return;

      const slide = productCard.querySelector('slideshow-slide[slide-id="' + baseMediaId + '"]');
      if (!slide) return;

      const img = slide.querySelector('img');
      if (!img) return;

      const srcset = img.getAttribute('srcset') || '';
      if (srcset.includes(targetImgKey)) {
        img.setAttribute('srcset', srcset.replaceAll(targetImgKey, baseImgKey));
      }
      const src = img.getAttribute('src') || '';
      if (src.includes(targetImgKey)) {
        img.setAttribute('src', src.replace(targetImgKey, baseImgKey));
      }
    });
  }

  function setupSplitCardHoverSlide(card) {
    const productCard = card.querySelector('product-card');
    if (!productCard) return;
    const hoverSlide = productCard.querySelector('slideshow-slide[data-hover-slide]');
    if (!hoverSlide) return;

    let currentHoverKey = card.dataset.activeHoverKey || '';
    let hoverImgMap = {};
    try { hoverImgMap = JSON.parse(card.dataset.hoverImgMap || '{}'); } catch (e) {}

    productCard.addEventListener('variant:update', function() {
      const variantPicker = productCard.querySelector('swatches-variant-picker-component');
      const selectedOption = variantPicker && variantPicker.querySelector('fieldset input:checked');
      const selectedMediaId = selectedOption?.dataset.optionMediaId;
      const newHoverKey = selectedMediaId != null ? (hoverImgMap[selectedMediaId] ?? '') : '';

      if (newHoverKey && currentHoverKey && newHoverKey !== currentHoverKey) {
        const img = hoverSlide.querySelector('img');
        if (img) {
          const srcset = img.getAttribute('srcset') || '';
          if (srcset.includes(currentHoverKey)) {
            img.setAttribute('srcset', srcset.replaceAll(currentHoverKey, newHoverKey));
          }
          const src = img.getAttribute('src') || '';
          if (src.includes(currentHoverKey)) {
            img.setAttribute('src', src.replace(currentHoverKey, newHoverKey));
          }
        }
        currentHoverKey = newHoverKey;
      }

      hoverSlide.hidden = !newHoverKey;
    });
  }

  function initSplitCard(card) {
    reorderSplitCardSwatch(card, true);
    setupSplitSwatchObserver(card);
    setupSplitCardImageFix(card);
    setupSplitCardHoverSlide(card);
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      document.querySelectorAll('li[data-active-color]').forEach(initSplitCard);
      const list = document.querySelector('results-list');
      if (list) {
        new MutationObserver((mutations) => {
          for (const { addedNodes } of mutations) {
            for (const node of addedNodes) {
              if (!(node instanceof HTMLElement)) continue;
              if (node.matches('li[data-active-color]')) initSplitCard(node);
              node.querySelectorAll('li[data-active-color]').forEach(initSplitCard);
            }
          }
        }).observe(list, { childList: true, subtree: true });
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
